<template>
  <m-dialog
    ref="dlgSetJadwal"
    @save="save"
    :title="
      settingJadwal && settingJadwal.settingJadwal_id
        ? 'Set Jadwal Kerja Per Orang'
        : 'Set Jadwal Kerja Per Orang'
    "
  >
    <v-container>
      <v-row row wrap justify="center" align="center">
        <v-col cols="12" sm="10" md="7" lg="7" xl="7">
          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <v-layout wrap>
              <v-flex xs12 md6 lg6 xl6 class="py-0">
                <label class="caption mb-2 primary--text">Pilih Anggota</label>
                <v-autocomplete
                  dense
                  single-line
                  outlined
                  v-model="settingJadwal.user_id"
                  hint="Pilih Anggota"
                  :items="users"
                  label="Anggota"
                  persistent-hint
                  item-text="nama"
                  item-value="user_id"
                  prepend-icon="mdi-account"
                >
                  <template slot="item" slot-scope="data">
                    <!-- HTML that describe how select should render selected items -->
                    <strong class="primary--text">{{ data.item.nama }}</strong>
                    &nbsp;({{ data.item.email }})
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 lg6 xl6 class="py-0">
                <label class="caption mb-2 primary--text"
                  >Pilih Jam Kerja</label
                >
                <v-select
                  dense
                  single-line
                  outlined
                  prepend-icon="mdi-clock"
                  :items="jamKerjas"
                  name="jam kerja"
                  label="Pilih Jam Kerja"
                  v-model="settingJadwal.konfigurasi_jadwal_id"
                  hint="Jam Kerja"
                  data-vv-name="konfigurasi_jadwal_id"
                  data-vv-as="konfigurasi_jadwal_id"
                  item-text="nama"
                  item-value="konfigurasi_jadwal_id"
                  :error-messages="errors.collect('form.konfigurasi_jadwal_id')"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </m-dialog>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      settingJadwal: {},
      jamKerjas: [],
      users: []
    };
  },
  methods: {
    // eslint-disable-next-line
    openSetJadwal(obj) {
      this.$validator.reset();
      this.getUser();
      this.getJadwalKerja();
      return this.$refs.dlgSetJadwal.open();
    },
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store.dispatch("jadwalKerja/form", Object.assign({}, { kode_organisasi: this.organisasi_id || ''} , this.settingJadwal));
        })
        .then(res => {
          this.$refs.dlgSetJadwal.resolve();
          this.$router.push({ name: "jamKerja" });
          return res;
        })
        .catch(e => e);
    },
    getUser() {
      this.$store
        .dispatch("user/get", {
          organisasi_id: this.organisasi_id || this.tenant_id
        })
        .then(res => {
          this.users = res.data;
        });
    },
    getJadwalKerja() {
      this.$store
        .dispatch("jamKerja/get", {
          organisasi_id: this.organisasi_id || this.tenant_id
        })
        .then(res => {
          this.jamKerjas = res.data.data;
        });
    }
    // add() {
    //   this.$refs.dlgSetJadwal
    //     .open()
    //     .then(() => {
    //       this.getJadwalKerja();
    //     })
    //     .catch(e => e);
    // },
    // edit(item) {
    //   this.$refs.dlgSetJadwal
    //     .open(item)
    //     .then(() => {
    //       this.getJadwalKerja();
    //     })
    //     .catch(e => e);
    // }
  }
};
</script>
